import React from 'react'
import './index.less'
import ImageBox from '../imageBox/index.jsx'
console.log(React)

export default function SetPage(props) {
  return (<div className='setPage'>
    <div className='setPage_sharingSettings'>
      <div className='sharingSettings_titleArea'>
        <h3 className='title'>分享设置</h3>
        <span className='tips'>设置推广页的分享样式</span>
      </div>
      <div className='sharingSettings_mainArea'>
        <div className='main_item'>
          <span className='item_title'>分享标题</span>
          <div className='item_main'>
            <input className='main_input' placeholder='建议与详情页面主体相符' value={props.sharingSettings.title} onChange={(e) => {
              if (e.target.value.length <= 14) {
                props.setSharingSettings && props.setSharingSettings({
                  ...props.sharingSettings,
                  title: e.target.value
                })
              }
            }} />
            <span className='main_tips'>{props.sharingSettings.title.length}/14</span>
          </div>
        </div>

        <div className='main_item'>
          <span className='item_title'>分享描述</span>
          <div className='item_main'>
            <input className='main_input' placeholder='对标题的简要解读' value={props.sharingSettings.describe} onChange={(e) => {
              if (e.target.value.length <= 20) {
                props.setSharingSettings && props.setSharingSettings({
                  ...props.sharingSettings,
                  describe: e.target.value
                })
              }
            }} />
            <span className='main_tips'>{props.sharingSettings.describe.length}/20</span>
          </div>
        </div>

        <div className='main_item' style={{
          alignItems: 'flex-start'
        }}>
          <span className='item_title'>分享缩略图</span>
          <div className='item_main'>
            <ImageBox src={props.sharingSettings.thumbnail.path} change={props.hoistPopup} mySwitch={props.hoistPopup}></ImageBox>
            <div className='myTips'>
              支持自定义上传 <br /> 图片尺寸：250×250像素 <br /> 图片格式：大小要求在300KB以内，若超出系统会自动压缩，仅支持jpg和png格式
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='setPage_shareStyle'>
      <h3 className='shareStyle_title'>
        分享样式预览
      </h3>
      <div className='shareStyle_main'>
        <div className='main_item'>
          <span className='item_title'>分享到朋友圈</span>
          <div className='item_main'>
            <div className='main_img'>
              <img src='https://wxa.wxs.qq.com/res/images/canvas_preview/wxad_logo.png' className='img' />
            </div>
            <div className='main_ifon'>
              <h3 className='ifon_title'>公众号名称</h3>
              <div className='ifon_main'>
                <img src={props.sharingSettings.thumbnail.path ? props.sharingSettings.thumbnail.path : 'https://wxa.wxs.qq.com/res/images/canvas_preview/wxad_logo.png'} className='img' />
                <span className='tips'>
                  {props.sharingSettings.title.length ? props.sharingSettings.title : '分享到朋友圈时候文案预览，文字过多时换行显示'}</span>
              </div>
              <span className='tips'>2 分钟前</span>
            </div>
          </div>
        </div>

        <div className='main_item' style={{
          marginTop: '21px'
        }}>
          <span className='item_title'>分享到会话</span>
          <div className='item_main1'>
            <div className='main1_div1'>
              <p className='div1_p'>{props.sharingSettings.title ? props.sharingSettings.title : '分享到朋友圈时候文案预览，文字过多时换行显示'}</p>
              <div className='div1_div'>
                <span className='div_span'>{props.sharingSettings.describe ? props.sharingSettings.describe : '分享到朋友圈时候文案预览，文字过多时换行显示'}</span>
                <img className='div_img' src={props.sharingSettings.thumbnail.path ? props.sharingSettings.thumbnail.path : 'https://wxa.wxs.qq.com/res/images/canvas_preview/wxad_logo.png'} />
              </div>
            </div>
            <div className='main1_div2'>
              <img className='div2_img' src='https://wxa.wxs.qq.com/res/images/canvas_preview/wxad_logo.png' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}
